module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABHElEQVRIie3UsS4EQRgH8N8hWg0aOkRDFN5BhYpIrhCJ5CJKlUalEJ1KdELiBagULpSewxPQSBBkktlkTNzdnuwlivuqmezk999vdnb0q1PVFte/erFJ87jF01CP8CZGMThQMT6b4C9YrTJgGncJvoTHqgICfo+JFA8PqghI8dewLQVeRcBkhi/jIV0QAho4xHAFeDNfFI7paThOWMAa3rrAp9rhRQdHcbyC8xhWFn/HRiu8CDjAcZzXcdkmZCxiBR46vmn3NsVH3sdJh5ACn0nw6w7d/jhFezjLQmoZPoePsngeEG693SwkHIDxBP/EVllci9u0FuGdOH/GSMQ3cVUWzzvIO7mI8z/j4n/wW4WQ7QjX47hrvF//oPANSyNCm5Z1CRUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/family/index_home_choose.png
// module id = tTe5
// module chunks = 1